{
  "alignment": {
    "attestedIn": "belegt in {{references}}",
    "noDecision": "Weder eine Zuordnung noch eine Begründung für eine fehlende Entsprechung im Referenzvokabular ist festgehalten.",
    "noDefinition": "Keine Definition.",
    "noEvidence": "kein Beleg im Originaltext",
    "noReferenceMatch": "Keine Entsprechung im Referenzvokabular:",
    "note": "Jeder neue Begriff neben den Konzepten, denen er in den gebundenen Referenzvokabularen ({{vocabularies}}) zugeordnet ist. Ob zwei Definitionen dasselbe meinen, beurteilen Sie: Schicken Sie die Änderung zurück, oder bestätigen Sie einen gewollten Unterschied mit einem Grund.",
    "parentDifference": "Oberbegriff weicht ab:",
    "parents": "Oberbegriffe: {{parents}}",
    "proposed": "Vorgeschlagener Begriff",
    "reference": "Konzept im Referenzvokabular",
    "title": "Abgleich mit Referenzvokabularen",
    "unknownConcept": "Kein gebundenes Referenzvokabular enthält dieses Konzept.",
    "unreadable": "Ein Referenzvokabular ließ sich nicht lesen: {{problem}}"
  },
  "changes": {"added": "neu", "modified": "geändert", "removed": "entfernt"},
  "checks": {
    "findingCounts": "{{shown}} angezeigt · {{listed}} aufgeführt · {{total}} insgesamt",
    "kinds": {
      "competency_question": "Frage",
      "consistency": "Konsistenz",
      "run": "Durchlauf",
      "shapes": "Shapes",
      "test_data": "Testdaten",
      "unsatisfiable_classes": "Unerfüllbare Klassen"
    },
    "notRun": "Diese Version wurde nicht geprüft.",
    "process": "Prozessprüfungen",
    "processNote": "Shapes und Fragen des Prozessgraphen: Konventionen, Wiederverwendung und der Lebenszyklus der Prozesselemente. Neue Shapes-Verletzungen müssen vor dem Übernehmen behoben werden; bereits bestehende Befunde müssen Sie bestätigen.",
    "questionCoverage_one": "{{count}} Frage: {{checked}} geprüft, {{notChecked}} nicht geprüft.",
    "questionCoverage_other": "{{count}} Fragen: {{checked}} geprüft, {{notChecked}} nicht geprüft.",
    "ruleSet_one": "Gelaufen: {{name}}, {{count}} Regel ({{rules}}). Bestanden heißt nur, dass diese Regel nichts gefunden hat.",
    "ruleSet_other": "Gelaufen: {{name}}, {{count}} Regeln ({{rules}}). Bestanden heißt nur, dass diese Regeln nichts gefunden haben.",
    "status": {
      "cannot_run": "Nicht ausführbar",
      "fail": "Fehlgeschlagen",
      "not_checked": "Nicht geprüft",
      "pass": "Bestanden"
    },
    "title": "Prüfungen dieser Version"
  },
  "collaboration": {
    "bulk": {
      "keepConfirm_one": "{{count}} neuen Begriff behalten",
      "keepConfirm_other": "{{count}} neue Begriffe behalten",
      "keepOffer_one": "{{count}} neuen Begriff mit Wert unter {{threshold}} behalten",
      "keepOffer_other": "{{count}} neue Begriffe mit Wert unter {{threshold}} behalten",
      "keepRow": "{{term}} könnte {{target}} doppeln (Wert {{score}})",
      "markConfirm_one": "{{count}} Abschnitt jetzt als gesichtet markieren",
      "markConfirm_other": "{{count}} Abschnitte jetzt als gesichtet markieren",
      "markOffer_one": "{{count}} Abschnitt als gesichtet markieren",
      "markOffer_other": "{{count}} Abschnitte als gesichtet markieren",
      "nothing": "Hier ist nichts sicher gesammelt zu entscheiden. Abschnitte mit Befunden, möglichen Dubletten oder fehlschlagenden Prüfungen werden einzeln entschieden.",
      "reason": "Warum das keine Dubletten sind",
      "title": "Gesammelt entscheiden"
    },
    "inbox": {
      "approved": "Jedes Element freigegeben",
      "askedBy": "Gebeten von {{names}}",
      "badge_one": "{{count}} Sache wartet auf Sie",
      "badge_other": "{{count}} Sachen warten auf Sie",
      "checks": {"cannot_run": "Prüfungen konnten nicht laufen", "fail": "Prüfungen schlagen fehl"},
      "duplicates_one": "{{count}} mögliche Dublette zu klären",
      "duplicates_other": "{{count}} mögliche Dubletten zu klären",
      "effect": {
        "approve_one": "Review · {{count}} Änderung freigeben",
        "approve_other": "Review · {{count}} Änderungen freigeben",
        "basis": "DMW-Basis · Bibliotheksaktualisierung freigeben",
        "review_one": "Review · {{count}} Änderung ansehen",
        "review_other": "Review · {{count}} Änderungen ansehen",
        "revise_one": "Vorschlag · {{count}} Änderung überarbeiten",
        "revise_other": "Vorschlag · {{count}} Änderungen überarbeiten"
      },
      "sections": {
        "myOpenProposals": {"shelf": "Meine offenen Vorschläge ({{count}})"},
        "waitingForMe": {"title": "Eingabe"}
      },
      "sentBackBy": "Zurückgegeben von {{name}}:",
      "toApprove": "Ihre Freigabe",
      "waitingApprovals_one": "Wartet auf {{count}} Freigabe",
      "waitingApprovals_other": "Wartet auf {{count}} Freigaben"
    },
    "labels": {
      "added": "Hinzugefügt: {{name}}",
      "byHand": "Von Hand geschrieben: Es gelten keine Erzeugungsregeln, also gibt es nichts abzugleichen.",
      "changed": "Geändert: {{name}}",
      "decide": "Braucht eine Entscheidung",
      "dropLink": "Verweis entfernen",
      "fields": {
        "description": "Beschreibung",
        "examples": "Beispiele",
        "guidelines": "Richtlinien",
        "name": "Name",
        "ontology_terms": "Ontologie-Begriffe"
      },
      "labels": "Labels",
      "linkRemoved": "{{label}} verweist auf {{term}}, den dieser Änderungssatz entfernt.",
      "linkRenamed": "{{label}} verweist auf {{term}}, den dieser Änderungssatz in {{renamedTo}} umbenennt.",
      "noLabelChange": "Kein Label hat sich geändert.",
      "nothingToDecide": "Jedes Label verweist auf Begriffe, die bleiben.",
      "removed": "Entfernt: {{name}}",
      "retarget": "Stattdessen auf {{term}} verweisen",
      "rules": "Regeln",
      "unchanged_one": "{{count}} Label unverändert",
      "unchanged_other": "{{count}} Labels unverändert"
    },
    "presence": {
      "at": "{{name}}, bei {{unit}}",
      "here": "Gerade hier:",
      "isHere": "Auch hier: {{names}}",
      "label": "Wer dieses Review offen hat",
      "newHead": "Dieser Änderungssatz hat eine neue Version, seit Sie ihn geöffnet haben. Markierungen an unveränderten Abschnitten gelten weiter.",
      "reload": "Neu laden"
    },
    "requests": {
      "ask": "Jemanden um Durchsicht bitten",
      "asked": "{{from}} bat {{to}}",
      "choose": "Mitglied wählen",
      "curates": "{{name}}, kuratiert {{items}}",
      "decline": "Ablehnen",
      "declineReason": "Warum Sie ablehnen",
      "nobody": "Kein anderes Mitglied ist in diesem Projekt.",
      "none": "Niemand wurde gebeten, sich das anzusehen.",
      "note": "Worauf soll die Person achten?",
      "scope": "Was ansehen",
      "send": "Bitten",
      "states": {
        "declined": "Abgelehnt",
        "done": "Erledigt",
        "open": "Offen",
        "withdrawn": "Zurückgezogen"
      },
      "thisUnit": "Dieser Abschnitt",
      "title": "Um Durchsicht gebeten",
      "units_one": "{{count}} Abschnitt",
      "units_other": "{{count}} Abschnitte",
      "whole": "Ganzer Änderungssatz",
      "whom": "Wen bitten",
      "withdraw": "Zurückziehen"
    }
  },
  "conflicts": {
    "derivedSourceChanged": "wird aus dem erstellt, was diese Änderung ändert. Führen Sie nach dem Übernehmen erneut aus, was es erstellt.",
    "none": "Diese Änderung berührt nichts, worauf sich andere Elemente stützen.",
    "notRun": "Die Konfliktprüfung ist für diese Version noch nicht gelaufen.",
    "regressed": "Die Prüfung „{{check}}“ war erfolgreich und schlägt jetzt fehl.",
    "regressedItem": "Die Prüfung dazu war erfolgreich und schlägt jetzt fehl.",
    "regressedUnnamed": "Eine Prüfung war erfolgreich und schlägt jetzt fehl.",
    "reliesOn": "stützt sich auf",
    "renamed": "{{term}} heißt jetzt wahrscheinlich {{renamedTo}}",
    "rerun": "Erneut prüfen",
    "rules": "Regeln {{version}}",
    "title": "Konflikte mit früheren Entscheidungen",
    "unused": "{{term}}: {{changes}}; nichts Verbundenes verwendet es.",
    "via": "über das, was es festlegt"
  },
  "curation": {
    "actionBar": "Aktionen zu diesem Abschnitt",
    "actions": {"add": "Hinzufügen", "replace": "Ersetzen", "skip": "Überspringen"},
    "affectedExplained": "Der Änderungssatz ändert dieses Element nicht, aber es verwendet Begriffe, die der Änderungssatz ändert. Sie können kommentieren; es blockiert nichts.",
    "after": "Nachher",
    "before": "Vorher",
    "candidates": {
      "apply": "Anwenden",
      "dismiss": "Keine Dublette…",
      "dismissReason": "Warum es keine Dublette ist",
      "dismissSend": "Zurückweisen",
      "inModule": "in {{name}}",
      "none": "Keine möglichen Dubletten",
      "propose": "Könnte einen anderen Begriff doppeln…",
      "readOnly": "Nur wer Änderungen vorschlagen darf, kann das klären.",
      "reason": "Grund (optional)",
      "resolution": "Entscheidung",
      "suggestsMerge": "Vorschlag: zusammenführen",
      "target": "Mögliche Dublette von",
      "title_one": "{{count}} mögliche Dublette",
      "title_other": "{{count}} mögliche Dubletten"
    },
    "changes": {"added": "neu", "changed": "geändert", "removed": "entfernt"},
    "columns": {"context": "Kontext", "outline": "Gliederung"},
    "comment": "Kommentar",
    "compare": {
      "caption": "{{term}} und {{target}}, Feld für Feld",
      "choice": "Beim Zusammenführen",
      "field": "Feld",
      "hideSame": "Gleiche Felder ausblenden",
      "newTerm": "Neu: {{name}}",
      "nothingToAdd": "nichts hinzuzufügen",
      "showSame_one": "{{count}} gleiches Feld zeigen",
      "showSame_other": "{{count}} gleiche Felder zeigen",
      "target": "Vorhanden: {{name}}"
    },
    "context": {
      "anyone": "Wer kommentieren darf, kann das markieren.",
      "decides": "Wer entscheidet",
      "discussion": "Diskussion",
      "label": "Kontext dieses Abschnitts",
      "marks": "Markierungen",
      "noMarks": "Noch hat niemand das markiert.",
      "othersCurate": "von anderen kuratiert",
      "outdated": "früherer Stand",
      "youCurate": "Sie kuratieren es"
    },
    "decide": {
      "unmarked_one": "{{count}} Ihrer Abschnitte ist nicht als gesichtet markiert. Änderungssatz trotzdem freigeben?",
      "unmarked_other": "{{count}} Ihrer Abschnitte sind nicht als gesichtet markiert. Änderungssatz trotzdem freigeben?"
    },
    "download": {
      "markdown": "Vorschlag als Markdown",
      "open": "Herunterladen",
      "turtle": "{{name}} als Turtle"
    },
    "edit": {
      "explain": "Speichert eine neue Version dieses Änderungssatzes. Prüfungen und Konfliktprüfung laufen erneut; Markierungen an unveränderten Abschnitten bleiben.",
      "open": "Turtle bearbeiten",
      "save": "Als neue Version speichern",
      "title": "{{name}} bearbeiten"
    },
    "evidence": {
      "lexical": "Namen",
      "rationale": "Begründung",
      "semantic": "Bedeutung",
      "structural": "Struktur",
      "usage": "Verwendung"
    },
    "explain": {
      "drop_new": "Entfernt aus diesem Änderungssatz alle Aussagen, die {{term}} nennen, sowie die zugehörigen Verweise in Labellisten. Nicht möglich, solange sich eine Frage des Änderungssatzes auf den Begriff bezieht.",
      "keep_new": "Behält {{term}} als eigenen Begriff.",
      "merge_into": "Entfernt {{term}}, schreibt {{target}} überall dort, wo der Änderungssatz ihn verwendet hat (Ontologiemodule, Shapes, Beispiele, Fragen, Labellisten), und wendet die Feldauswahl auf {{target}} an."
    },
    "fields": {
      "altLabel": "Weitere Bezeichnung",
      "comment": "Kommentar",
      "definedBy": "Definiert in",
      "definition": "Definition",
      "domain": "Gilt für (Domain)",
      "example": "Beispiel",
      "label": "Bezeichnung",
      "parent": "Oberbegriff",
      "range": "Werte (Range)",
      "seeAlso": "Siehe auch"
    },
    "fieldsCaption": "{{name}}, Feld für Feld, vorher und nachher",
    "focusLabel": "Abschnitt im Fokus",
    "itemSentence": {
      "added": "Fügt {{name}} hinzu.",
      "modified": "Ändert {{name}}.",
      "removed": "Entfernt {{name}}."
    },
    "keep": {
      "module": "Ontologiemodul",
      "moduleUnchanged": "Bleibt in {{name}}",
      "narrower": "als engerer Begriff von {{target}}"
    },
    "keys": {
      "close": "Notiz oder Hilfe schließen",
      "columns": "Gliederung und Kontext aus- oder einblenden",
      "comment": "Diesen Abschnitt kommentieren",
      "decide": "Änderungssatz freigeben, Änderungen erbitten, Änderungssatz übernehmen",
      "filter": "Gliederung filtern",
      "help": "Tasten zeigen",
      "needsChange": "Braucht eine Änderung, mit Notiz",
      "ok": "Als gesichtet markieren",
      "resolve": "Neuen behalten, zusammenführen, neuen verwerfen",
      "technical": "Technische Details ein oder aus",
      "title": "Tasten",
      "units": "Nächster oder vorheriger Abschnitt",
      "unresolved": "Nächster oder vorheriger ungeklärter Abschnitt"
    },
    "kinds": {
      "affected": "das Element",
      "checks": "die Prüfung",
      "classes": "die Klasse",
      "conversation": "die Review-Übersicht",
      "individuals": "das Individuum",
      "items": "das Element",
      "properties": "die Eigenschaft",
      "terms": "den Begriff"
    },
    "marks": {
      "clearOk": "Als gesichtet markiert · rückgängig",
      "needsChange": "Braucht eine Änderung",
      "notYours": "Sie kuratieren kein Element dieses Abschnitts.",
      "note": "Was sich ändern muss",
      "ok": "Gesichtet",
      "sendNote": "Senden",
      "short": {"needs_change": "braucht eine Änderung", "ok": "gesichtet"}
    },
    "nextUnresolved": "Nächster offener",
    "openDecisions_one": "{{count}} offene Entscheidung",
    "openDecisions_other": "{{count}} offene Entscheidungen",
    "otherAdded_one": "{{count}} weitere Aussage hinzugefügt",
    "otherAdded_other": "{{count}} weitere Aussagen hinzugefügt",
    "otherRemoved_one": "{{count}} weitere Aussage entfernt",
    "otherRemoved_other": "{{count}} weitere Aussagen entfernt",
    "outline": {
      "conversation": "Review-Übersicht",
      "duplicate": "mögliche Dublette",
      "filter": {
        "all": "Alle",
        "duplicates": "Mögliche Dubletten",
        "needs_me": "Braucht mich",
        "open": "Offen"
      },
      "filters": "Zeigen",
      "groups": {
        "affected": "Betroffene Elemente",
        "checks": "Prüfungen",
        "classes": "Klassen",
        "conversation": "Review-Übersicht",
        "individuals": "Individuen",
        "items": "Elemente",
        "properties": "Eigenschaften",
        "terms": "Weitere Begriffe"
      },
      "label": "Gliederung des Reviews",
      "needsMe": "braucht Sie",
      "search": "Abschnitte filtern",
      "units": "Review-Abschnitte"
    },
    "rename": {
      "explain": "Schreibt die neue IRI in jedes Ontologiemodul und in die Beispiele, Fragen und Labellisten dieses Änderungssatzes, als eine neue Version.",
      "label": "Neue IRI",
      "open": "IRI umbenennen…",
      "send": "Umbenennen"
    },
    "resolutions": {
      "drop_new": "3 · Neuen verwerfen",
      "keep_new": "1 · Neuen behalten",
      "merge_into": "2 · Zusammenführen mit {{target}}"
    },
    "resolved": {
      "drop_new": "Verworfen von {{name}}",
      "dropped_one": "{{count}} Aussage ohne Ersatz entfernt",
      "dropped_other": "{{count}} Aussagen ohne Ersatz entfernt",
      "item": "{{name}}: {{uses}}, {{added}} hinzugefügt, {{removed}} entfernt",
      "keep_new": "Von {{name}} als eigener Begriff neben {{target}} beibehalten",
      "merge_into": "Von {{name}} mit {{target}} zusammengeführt",
      "noCommit": "Nichts zu ändern: keine neue Version.",
      "uses_one": "{{count}} Verwendung umgeschrieben",
      "uses_other": "{{count}} Verwendungen umgeschrieben"
    },
    "scores": {
      "lexical": "Namen {{value}}",
      "semantic": "Bedeutung {{value}}",
      "structural": "Struktur {{value}}"
    },
    "sentence": {
      "added": "Fügt {{kind}} {{name}} hinzu",
      "changed": "Ändert {{kind}} {{name}}",
      "parents": ", eine Art von {{names}}",
      "removed": "Entfernt {{kind}} {{name}}"
    },
    "sources": {
      "agent_turn": "Von einem Agenten in einem Durchlauf vorgeschlagen",
      "builtin_lexical": "Von DMWs Namensabgleich gefunden",
      "person": "Von einer Person vorgeschlagen",
      "tool_run": "Von einer Äquivalenzprüfung in einem Durchlauf gefunden"
    },
    "states": {
      "dismissed": "Keine Dublette von {{target}}",
      "open": "Mögliche Dublette von {{target}}",
      "resolved": "Geklärt: {{target}}",
      "superseded": "Gilt nicht mehr: Der Begriff hat sich geändert ({{target}})"
    },
    "technical": "Technische Details",
    "technicalMore_one": "{{count}} weitere Aussage ist nicht aufgeführt.",
    "technicalMore_other": "{{count}} weitere Aussagen sind nicht aufgeführt.",
    "usedByNone": "Kein verbundenes Element verwendet diesen Begriff.",
    "usedBy_one": "Von {{count}} Element verwendet",
    "usedBy_other": "Von {{count}} Elementen verwendet"
  },
  "decisions": {
    "acknowledged": "bestätigt: {{note}}",
    "actions": {
      "approve": "Änderungssatz freigeben",
      "request_changes": "Zurücksenden",
      "scrap": "Verwerfen"
    },
    "barLabel": "Ihre Entscheidung",
    "by": "von {{name}} {{time}}",
    "byYou": "von Ihnen {{time}}",
    "commentFor": {
      "approve": "Kommentar (optional)",
      "merge": "Warum diesen Änderungssatz übernehmen?",
      "request_changes": "Was soll sich ändern?",
      "resubmit": "Was haben Sie geändert? (optional)",
      "scrap": "Warum verwerfen?"
    },
    "external": {
      "author": "Ursprünglicher Autor: {{name}}",
      "explanation": "Historischer Nachweis; diese Entscheidungen zählen nicht als lokale Freigaben.",
      "head": "Ursprünglich gesichtete Version: {{head}}",
      "invited": "eingeladenes Konto; E-Mail nicht verifiziert",
      "matched": "verifiziertes Konto zugeordnet",
      "title": "Importierter Review-Verlauf",
      "unmatched": "nicht zugeordneter externer Reviewer"
    },
    "kinds": {
      "approve": "Freigegeben",
      "merge": "Übernommen",
      "request_changes": "Änderungen erbeten",
      "scrap": "Verworfen"
    },
    "mergeApprovals": {"by": "nach Freigabe durch {{names}}", "none": "ohne gesonderte Freigabe"},
    "none": "Noch hat niemand entschieden.",
    "notCurator": "Sie kuratieren keines der geänderten Elemente: Sie können mitdiskutieren, aber nicht entscheiden.",
    "outdated": "zu einer früheren Version",
    "resubmit": "Erneut zum Review einreichen",
    "resubmitReason": "Änderungen wie erbeten vorgenommen.",
    "title": "Entscheidungen"
  },
  "fold": {
    "fold": "Darin zusammenfassen",
    "keep": "Behalten",
    "open": "Zusammenfassen…",
    "question": "Wortlaut",
    "submit": "Zusammenfassen"
  },
  "graphDiff": {
    "abstractStep": "abstrakter Schritt",
    "binding": "Verbindung {{target}} ← {{source}}",
    "bindings": "Verbindungen",
    "inputs": "Eingaben",
    "pipeline": "Hauptablauf",
    "subWorkflow": "Teilprozessschema"
  },
  "inThread": {
    "decidedIn": "In seinem Durchlauf entschieden",
    "elsewhere": "Über diesen Änderungssatz entscheidet ein anderer Durchlauf; dort wird geantwortet.",
    "noChangeSet": "Die Eingabe dieses Review-Schritts nennt noch keinen Änderungssatz.",
    "openOwner": "Diesen Durchlauf öffnen"
  },
  "index": {
    "conflicts_one": "{{count}} Konflikt",
    "conflicts_other": "{{count}} Konflikte",
    "items_one": "{{count}} Element",
    "items_other": "{{count}} Elemente"
  },
  "item": {
    "added_one": "{{count}} Aussage hinzugefügt",
    "added_other": "{{count}} Aussagen hinzugefügt",
    "approvedBy": "freigegeben durch {{names}}",
    "axiom": "ein Axiom",
    "changedFields": "Geänderte Felder: {{fields}}",
    "discussion": "Diskussion dieses Elements",
    "fieldDiff": "Geänderte Felder",
    "graphDiff": "Prozessschema-Graph",
    "loadingDefinition": "Beide Versionen werden gelesen…",
    "loadingText": "Die Texte werden geladen …",
    "lookedAt": "Habe ich angesehen",
    "notApproved": "noch nicht freigegeben",
    "openNew": "Vorgeschlagene Version öffnen",
    "openOld": "Vorherige Version öffnen",
    "removed_one": "{{count}} Aussage entfernt",
    "removed_other": "{{count}} Aussagen entfernt",
    "textFields": {
      "body": "Anleitung",
      "content": "Inhalt",
      "description": "Beschreibung",
      "text": "Text"
    },
    "wholeAdded": "Neues Element: Öffnen Sie es, um die ganze Definition zu lesen.",
    "wholeRemoved": "Entferntes Element: Öffnen Sie die frühere Version, um es zu lesen."
  },
  "kinds": {"corpus": "Korpus", "knowledge_data": "Wissensdaten"},
  "levels": {
    "check": "Bitte ansehen",
    "checkExplained_one": "{{count}} zum Ansehen: etwas, worauf es sich stützt, hat seine Bedeutung geändert",
    "checkExplained_other": "{{count}} zum Ansehen: etwas, worauf sie sich stützen, hat seine Bedeutung geändert",
    "conflict": "Konflikt",
    "conflictExplained_one": "{{count}} stützt sich auf etwas, das fehlt oder ihm jetzt widerspricht",
    "conflictExplained_other": "{{count}} stützen sich auf etwas, das fehlt oder ihnen jetzt widerspricht",
    "info": "Info",
    "infoExplained_one": "{{count}} zur Information: nichts Verbundenes verwendet es",
    "infoExplained_other": "{{count}} zur Information: nichts Verbundenes verwendet sie"
  },
  "lifecycle": {
    "deprecatedNote": "Läuft noch, aber neue Pins werden gemeldet. Wechseln Sie zum Ersatz.",
    "noReplacement": "Nichts ersetzt es.",
    "reason": "Grund: {{reason}}",
    "replacedBy": "Ersetzt durch",
    "retiredNote": "Startet keinen neuen Durchlauf und keinen neuen Batch; laufende Arbeit endet normal, und ihre Ergebnisse bleiben gültig.",
    "state": {
      "active": "Aktiv",
      "deprecated": "Veraltet",
      "draft": "Entwurf",
      "retired": "Stillgelegt",
      "withdrawn": "Zurückgezogen"
    },
    "withdrawnNote": "Als falsch oder unsicher zurückgezogen: nichts führt es mehr aus, und laufende Durchläufe halten vor ihrem nächsten Turn an. Seine Ergebnisse stehen zum erneuten Review an."
  },
  "merge": {
    "acknowledge": "Ich habe die offenen Konflikte und fehlgeschlagenen oder fehlenden Prüfungen gesehen und übernehme trotzdem.",
    "action": "Änderungssatz übernehmen",
    "note": "Warum das Übernehmen trotzdem richtig ist (wird mit gespeichert)",
    "waiting_one": "{{count}} Element braucht noch die Freigabe seiner Kuratorin oder seines Kurators.",
    "waiting_other": "{{count}} Elemente brauchen noch die Freigabe ihrer Kuratorinnen oder Kuratoren."
  },
  "mergeBlocks": {
    "explanation": "Überarbeiten Sie vor dem Übernehmen das Datenmodell, seine Shapes oder seine Testdaten. Senden Sie diese Version mit den folgenden Befunden zurück.",
    "inconsistent": "Widersprüchliche Prüfungen:",
    "introduced": "Neue Shapes-Verletzungen und Testdaten, die die Änderung bricht:",
    "maintained": "Aktuell gehalten, mit dieser Änderung noch nicht neu erstellt:",
    "maintainedCycle_one": "{{count}} aktuell gehaltenes Element wird aus sich selbst erstellt.",
    "maintainedCycle_other": "{{count}} aktuell gehaltene Elemente werden auseinander erstellt.",
    "maintainedFix": {
      "change_declaration": "{{name}} lässt sich nicht erstellen: {{problem}}.",
      "rebuild": "{{name}}: wartet auf die Neuerstellung.",
      "update_from_main": "{{name}}: Die Hauptversion hat geändert, woraus es erstellt wird. Aktualisieren Sie diese Änderung daraus."
    },
    "more_one": "und {{count}} weitere",
    "more_other": "und {{count}} weitere",
    "noFocus": "Kein Bezug angegeben",
    "openRebuild": "Neuerstellung öffnen",
    "preExisting": "Bereits in der Ausgangsversion; diese Befunde verhindern das Übernehmen nicht:",
    "preExistingCount_one": "{{count}} Verletzung war schon in der Ausgangsversion; sie verhindert das Übernehmen nicht.",
    "preExistingCount_other": "{{count}} Verletzungen waren schon in der Ausgangsversion; sie verhindern das Übernehmen nicht.",
    "rebuildHere": "Auf meinem PC neu erstellen",
    "rebuildState": {
      "failed": "Die Neuerstellung ist fehlgeschlagen: {{problem}}",
      "running": "Die Neuerstellung läuft.",
      "waiting_for_host": "Die Neuerstellung wartet, bis der PC ihres Hosts online ist."
    },
    "title": "Diese Version kann nicht übernommen werden",
    "uncompared": "Nicht mit der Ausgangsversion verglichen, weil diese Prüfungen nur einen Teil ihrer Verletzungen aufführen oder der Ausgangsversion fehlen; ihre Befunde brauchen stattdessen die Bestätigung: {{checks}}",
    "updateFromMain": "Aus der Hauptversion aktualisieren"
  },
  "page": {
    "changes_one": "{{count}} geändertes Element",
    "changes_other": "{{count}} geänderte Elemente",
    "copyHead": "Den Commit dieser Version kopieren",
    "discussion": "Diskussion des ganzen Änderungssatzes",
    "proposed": "Vorgeschlagen von {{name}} {{time}}",
    "proposedByYou": "Von Ihnen vorgeschlagen {{time}}",
    "savedFrom": "Gespeichert aus Durchlauf",
    "termDiscussions": "Kommentare und Issues zu den berührten Begriffen",
    "threadEntry": "Durchlauf-Eintrag {{number}}"
  },
  "predicates": {
    "allValuesFrom": "auf nur",
    "comment": "wird beschrieben als",
    "disjointWith": "ist nie zugleich",
    "domain": "gilt für",
    "equivalentClass": "ist dasselbe wie",
    "inverseOf": "ist die Umkehrung von",
    "label": "heißt",
    "onProperty": "schränkt ein",
    "range": "verweist auf",
    "someValuesFrom": "auf mindestens ein",
    "subClassOf": "ist eine Art von",
    "subPropertyOf": "ist eine engere Form von",
    "type": "ist ein"
  },
  "states": {
    "merged": "Übernommen",
    "open": "Wartet auf Review",
    "scrapped": "Verworfen",
    "sent_back": "Zurückgeschickt"
  },
  "summary": {
    "approvalsMissing_one": "{{count}} Element braucht noch die Freigabe einer Kuratorin oder eines Kurators",
    "approvalsMissing_other": "{{count}} Elemente brauchen noch die Freigabe ihrer Kuratorinnen oder Kuratoren",
    "blocking_one": "{{count}} Befund braucht Aufmerksamkeit vor dem Übernehmen",
    "blocking_other": "{{count}} Befunde brauchen Aufmerksamkeit vor dem Übernehmen",
    "closed": {
      "merged": "Dieser Änderungssatz ist übernommen: Seine Elemente sind neue feste Versionen. Die Befunde unten zeigen den Stand der übernommenen Version.",
      "scrapped": "Dieser Änderungssatz ist verworfen. Beitragende können ihn wieder öffnen."
    },
    "nothingBlocking": "Keine Konflikte und keine fehlgeschlagenen Prüfungen",
    "openItems_one": "{{count}} Element zum Ansehen",
    "openItems_other": "{{count}} Elemente zum Ansehen"
  },
  "termChanges": {
    "added": "neu",
    "definition_changed": "Definition geändert",
    "hierarchy_changed": "Ober- oder Unterklassen geändert",
    "label_changed": "Bezeichnung geändert",
    "other_changed": "geändert",
    "removed": "entfernt",
    "renamed": "umbenannt",
    "signature_changed": "Domäne, Wertebereich oder Einschränkung geändert"
  },
  "you": "Sie"
}
